/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath } from "../../../utility/Constant";

const CertificateUniquePage = () => {
  const { certificateApi } = apiPath;
  const [certificateUniqueData, certificateUniqueLoading] =
    useFetch(certificateApi);
  const [filteredData, setFilteredData] = useState();
  let { certificateId } = useParams();

  useEffect(() => {
    setFilteredData(
      certificateUniqueData?.filter((item) => item._id === certificateId)[0]
    );
  }, [certificateUniqueData, certificateId]);

  if (certificateUniqueLoading || !filteredData?._id) {
    return <Loading />;
  }

  const { description, title, date, image, _id } = filteredData ?? {};

  const data = [
    {
      elementType: "input",
      label: "Certificate title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "textField",
      label: "Certificate description",
      type: "Text",
      name: "description",
      defaultValue: description,
      required: false,
    },
    {
      elementType: "input",
      label: "Certificate date",
      type: "Text",
      name: "date",
      defaultValue: date,
      required: false,
    },
    {
      elementType: "file",
      label: `Certificate Image`,
      name: "certificate_img",
      type: "file",
      fullCol: true,
      defaultValue: image,
      required: false,
    },
  ];

  const update = (data) => {
    const { certificate_img, ...rest } = data;
    rest.image = {
      url: certificate_img,
    };
    updateData(certificateApi, rest, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default CertificateUniquePage;
